import { render, staticRenderFns } from "./YoutubeWatcher.vue?vue&type=template&id=7a6bff05"
import script from "./YoutubeWatcher.vue?vue&type=script&lang=js"
export * from "./YoutubeWatcher.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports